import moment from 'moment';
import React, { useState } from 'react';

import DateSelectRange from '../../elements/DateSelectRange';
import ShowMetrics, { TYPE_METRICS, TimeRangeName } from '../../helpers/ShowMetrics';

function AffiliateOwnerMetrics({ url }: Readonly<{ url: string }>) {
    const [range, setRange] = useState<TimeRangeName>('last-week');
    const [startDate, setStartDate] = useState(moment().subtract(1, 'weeks').startOf('isoWeek'));
    const [endDate, setEndDate] = useState(moment().subtract(1, 'weeks').endOf('isoWeek'));
    const timeRange = { range, startDate, endDate };

    return (
        <div>
            <div className="row no-gutters">
                <div className="dashboard_date-select">
                    <DateSelectRange
                        range={range}
                        setRange={setRange}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </div>
            </div>
            <div className="row metrics">
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_users"
                    label="Users"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_ftd"
                    label="FTD"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_stp"
                    label="STP"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_std"
                    label="STD"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_deposits"
                    label="Deposits"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_deposits_sum"
                    label="Deposits sum"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_avg_user_value"
                    label="Average user value"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_avg_returning_user_value"
                    label="Average returning user value"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
                <ShowMetrics
                    url={url}
                    path="affiliate_owner_earning"
                    label="Earning"
                    typeMetrics={TYPE_METRICS.VALUE_METRIC}
                    timeRange={timeRange}
                />
            </div>
        </div>
    );
}

export default AffiliateOwnerMetrics;
